import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import { TeachingHall } from '../../../lib/types/models/ol/teaching-hall/teaching-hall'
import { encodeNestedObject } from '../../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export function getCenterTeachingHalls(id: number, query: PaginationRequest = {}) {
  return restApiClient
    .url(
      encodeNestedObject(constructApiUrl(API.centers.getCenterTeachingHalls.url, { id }), query)
    )
    .get<PaginationResponse<TeachingHall>>()
}
